import React from 'react'
import * as S from 'styles'

const Steps = ({ steps, numberOfSteps, activeStep, marginBottom = '0' }) => {
  return (
    <S.StepsContainer marginBottom={marginBottom}>
      <S.StepsWrapper length={numberOfSteps}>
        {steps.sort((a, b) => a.step - b.step).map(
          ({ step, label, active }, index) => {
            const isActive = (step <= activeStep || active)
            return (
              <React.Fragment key={`${step}-${index}`}>
                <S.Step active={isActive}>
                  <S.StepBall className={label} active={isActive} />
                </S.Step>
              </React.Fragment>
            )
          }
        )}
      </S.StepsWrapper>
    </S.StepsContainer>
  )
}

export default Steps
